import Color from 'color';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { getColorHexByName } from '../../utils/color.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import BaseIcon from '../BaseIcon/BaseIcon';
import LGBTQFlag from '../LGBTQFlag/LGBTQFlag';
import './SupportGroupIcon.scss';
var SupportGroupIcon = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get icon() {
            var _a, _b, _c, _d, _e;
            switch (true) {
                case (_e = (((_b = (_a = p.supportGroup) === null || _a === void 0 ? void 0 : _a.topic) === null || _b === void 0 ? void 0 : _b.slug) || ((_d = (_c = p.supportGroup) === null || _c === void 0 ? void 0 : _c.topic) === null || _d === void 0 ? void 0 : _d.displayName))) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes('lgbt'):
                    return React.createElement(LGBTQFlag, null);
                default:
                    return React.createElement(BaseIcon, { icon: "people", variant: "filled", size: p.size ? p.size * .5 : 24 });
            }
        },
        get color() {
            var _a, _b;
            return ((_b = (_a = p.supportGroup) === null || _a === void 0 ? void 0 : _a.topic) === null || _b === void 0 ? void 0 : _b.color) || getColorHexByName('blueGreen');
        },
        get backgroundImage() {
            return "radial-gradient(257.85% 97.17% at 34.88% 2.83%, " + s.color + " 0%, " + Color(s.color).lighten(.19).hex() + " 100%)";
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "SupportGroupIcon", style: {
                backgroundImage: s.backgroundImage,
                width: props.size,
                height: props.size,
            } }, s.icon)); } });
};
export default SupportGroupIcon;
